import { render, staticRenderFns } from "./PositionEdit.vue?vue&type=template&id=6d9edf3e&scoped=true&"
import script from "./PositionEdit.vue?vue&type=script&lang=ts&"
export * from "./PositionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PositionEdit.vue?vue&type=style&index=0&id=6d9edf3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9edf3e",
  null
  
)

export default component.exports